// Public storefront variants and USD prices checked 2026-10-16. Nine distinct products per model; sunshades excluded.
window.TES_MODEL_GROUPS = [
  {
    "name": "Model Y Juniper",
    "slug": "model-y-juniper-accessories",
    "title": "Your Juniper, Ready for Halloween",
    "copy": "Explore charging, all-weather floor protection and hidden cooling upgrades for your Model Y Juniper.",
    "items": [
      {
        "id": "model-0-0",
        "title": "Center Console USB Hub",
        "sourceTitle": "Center Console USB Hub for Tesla Model Y Juniper 2025+/ Model 3 Highland 2023+",
        "handle": "center-console-usb-hub-for-tesla-model-y-juniper-2025-model-3-highland-2023",
        "variant": "52297746710817",
        "price": 62,
        "fit": "Model Y Juniper（2025.03+）",
        "sourceVariant": "Model Y Juniper（2025.03+）",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Center_Console_USB_Hub_for_Tesla_Model_Y_Juniper_2025_Model_3_Highland_2023.png?v=1770357428",
        "tag": "CONSOLE ESSENTIAL"
      },
      {
        "id": "model-0-1",
        "title": "All-Weather Floor & Cargo Mat Set",
        "sourceTitle": "Model Y Juniper 2025+ All-Weather TPE Floor Mats & Pet Mats Bundle",
        "price": 240,
        "variant": "53025028014369",
        "fit": "Model Y Juniper · 2025+ · Left-hand drive · Floor mats and pet cargo liner",
        "handle": "model-y-juniper-2025-all-weather-tpe-floor-mats-pet-mats-bundle",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_TPE_Mats_Floor_Mats_For_Tesla_Model_Y_Juniper.jpg?v=1763449431",
        "source": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_TPE_Mats_Floor_Mats_For_Tesla_Model_Y_Juniper.jpg?v=1763449431",
        "sourceVariant": "Default Title",
        "checked": "2026-10-16"
      },
      {
        "id": "model-0-2",
        "title": "Hidden Trunk Fridge",
        "sourceTitle": "Trunk Fridge Hidden Cooler Car Mini Refrigerator for Tesla Model Y / Model Y Juniper – Fits 5-Seat Models Only",
        "handle": "tesstudio-hidden-trunk-fridge-tesla-model-y-juniper",
        "variant": "51261817782561",
        "price": 467,
        "fit": "Model Y Juniper 5-Seat (03/2025+) – Excl. Berlin",
        "sourceVariant": "Model Y Juniper 5-Seat (03/2025+) – Excl. Berlin",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Trunk_Fridge_Hidden_Cooler_Car_Mini_Refrigerator_for_Tesla_Model_Y_Model_Y_Juniper_-_Tesstudio.jpg?v=1779421937",
        "tag": "WEEKEND-READY"
      },
      {
        "id": "model-0-3",
        "title": "Car Door Seal Kit",
        "sourceTitle": "Car Door Seal Kit For Tesla Model 3/3 Highland/Y/Y Juniper/Y L/Y Standard | Soundproof Rubber Weatherstrip",
        "handle": "tesla-model-3-y-car-door-seal-kit-soundproof-rubber-accessories",
        "variant": "50758692143393",
        "price": 66,
        "fit": "Model Y/Y Juniper",
        "sourceVariant": "Model Y/Y Juniper",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Car_Door_Seal_Kit_Soundproof_Rubber_For_Tesla_Model_3_Y_Accessories.jpg?v=1761897470",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-0-4",
        "title": "V3 Screen Swivel Mount",
        "sourceTitle": "Dashboard Screen Swivel Mount kit For Model 3/Y/3 Highland/Model Y Juniper/Y L",
        "handle": "model-3-y-3-highland-model-y-juniper-dashboard-screen-swivel-mount-kit",
        "variant": "51206647972129",
        "price": 109,
        "fit": "Model Y Juniper（03/2025+） / New Upgraded V3 Version - does not lower the screen height / Left Hand Drive",
        "sourceVariant": "Model Y Juniper（03/2025+） / New Upgraded V3 Version - does not lower the screen height / Left Hand Drive",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Dashboard_Screen_Swivel_Mount_kit_For_Model_3_Y_3_Highland_Model_Y_Juniper_-_Tesstudio.png?v=1777017684",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-0-5",
        "title": "Fog Light Trim Covers",
        "sourceTitle": "ABS Fog Light Trim Covers Exterior Upgrade for Tesla Model Y L / Model Y Juniper 2025+",
        "handle": "fog-light-trim-covers-abs-exterior-upgrade-for-tesla-model-y-juniper",
        "variant": "52846708261153",
        "price": 88,
        "fit": "Model Y Juniper Premium 2025.03+ / Matte Carbon Fiber Style",
        "sourceVariant": "Model Y Juniper Premium 2025.03+ / Matte Carbon Fiber Style",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Fog_Light_Trim_Covers_Matte_Carbon_Fiber_Style.webp?v=1781493468",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-0-6",
        "title": "Armrest Storage Box",
        "sourceTitle": "Tesla Model Y / YL Center Console Storage Box | ABS+PVC OEM-Fit Interior Organizer",
        "handle": "center-console-storage-box-for-tesla-model-y-yl-2025-upgrade",
        "variant": "52885846327585",
        "price": 24,
        "fit": "Armrest storage box / Model Y Juniper 2025.03+",
        "sourceVariant": "Armrest storage box / Model Y Juniper 2025.03+",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/image_1.png?v=1782204914",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-0-7",
        "title": "Power Frunk Lift Kit",
        "sourceTitle": "Power Frunk Automatic opening system For Tesla Model 3/Y/3 Highland/ Y Juniper",
        "handle": "power-frunk-silent-front-trunk-electric-suction-lock-v8",
        "variant": "51004223422753",
        "price": 400,
        "fit": "Model Y Juniper （03/2025+）",
        "sourceVariant": "Model Y Juniper （03/2025+）",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Model_Y_Juniper_03_2025_Power_Frunk_Automatic_opening_system_For_Tesla_-_Tesstudio.jpg?v=1780556387",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-0-8",
        "title": "App-Controlled Door LED Lights",
        "sourceTitle": "Door LED Strip Lights with APP Control for Tesla Model 3 / 3 Highland / Model Y / Y Juniper/Y L",
        "handle": "door-led-strip-lights-with-app-control-for-tesla-model-3-y-interior-ambient-lighting",
        "variant": "52637428154657",
        "price": 115,
        "fit": "Model Y Juniper (2025.3+)",
        "sourceVariant": "Model Y Juniper (2025.3+)",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Door_LED_Strip_Lights_with_APP_Control_for_Tesla_Model_3_3_Highland_Model_Y_Y_Juniper_Interior_Ambient_Lighting.png?v=1778059776",
        "tag": "HALLOWEEN UPGRADE"
      }
    ]
  },
  {
    "name": "Model Y L",
    "slug": "2026-model-yl-accessories",
    "title": "More Room. More Ways to Make It Yours.",
    "copy": "Discover storage, dashboard and everyday organization upgrades for your Model Y L.",
    "items": [
      {
        "id": "model-1-0",
        "title": "Magnetic Under-Screen Storage Tray",
        "sourceTitle": "Tesla Model Y L Magnetic Under-Screen Storage Tray",
        "handle": "tesla-model-y-l-magnetic-under-screen-storage-tray",
        "variant": "53184419463457",
        "price": 62,
        "fit": "Model Y L (2026.06+) / Black",
        "sourceVariant": "Model Y L (2026.06+) / Black",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/tesla-magnetic-under-screen-storage-tray-semi-transparent-black_345aa7a5-cf7b-41c2-b5a6-ada485f2ed72.png?v=1785811253",
        "tag": "SMART STORAGE"
      },
      {
        "id": "model-1-1",
        "title": "F96C Dashboard Display",
        "sourceTitle": "F96C CarPlay Screen Dashboard Touchscreen Display For Tesla Model Y L",
        "handle": "carplay-screen-dashboard-touchscreen-display-for-tesla-model-y-l",
        "variant": "53071871803681",
        "price": 324,
        "fit": "Model Y L · 2026.03+ · Front camera · Left-hand drive",
        "sourceVariant": "Model Y L (2026.03+) / With front camera - Left Hand Drive",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/F96C.png?v=1784877037",
        "tag": "DRIVER TECH"
      },
      {
        "id": "model-1-2",
        "title": "Center Console Organizer",
        "sourceTitle": "Center Console Organizer Tray & Silicone Storage Box for Model Y L",
        "handle": "center-console-organizer-tray-silicone-storage-box-for-model-y-l",
        "variant": "53184532414753",
        "price": 19,
        "fit": "Model Y L · 2026.06+ · Organizer · Flocked surfaces only",
        "sourceVariant": "Model Y L (2026.06+) / Center Console Organizers",
        "imageUrl": window.TES_HW.assets["assets/bundles/bundle-1-3.jpg"],
        "tag": "EVERYDAY ORGANIZATION"
      },
      {
        "id": "model-1-3",
        "title": "Screen Protector & Frame Cover",
        "sourceTitle": "All-in-One Central Screen Tempered Glass & Frame Cover for Tesla Model 3/Y",
        "handle": "tesla-model-3-y-screen-frame-protector",
        "variant": "53047689675041",
        "price": 49,
        "fit": "Model Y L (2026.03+) / 16 Inch / Black",
        "sourceVariant": "Model Y L (2026.03+) / 16 Inch / Black",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Black.png?v=1784515594",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-1-4",
        "title": "15W Magnetic Wireless Charger",
        "sourceTitle": "15W Magnetic Wireless Car Charger Mount for Tesla Model Y L 2026.06+",
        "handle": "15w-magnetic-wireless-car-charger-mount-for-tesla-model-y-l",
        "variant": "53186154627361",
        "price": 52,
        "fit": "Model Y L (2026.06+) / White",
        "sourceVariant": "Model Y L (2026.06+) / White",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Fast_Charging_Wireless_Car_Charger_Mount_Magnetic_Foldable_Car-Phone_Holder_For_Tesla_Model_3_Y.jpg?v=1772781802",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-1-5",
        "title": "Carbon Fiber Armrest Cover",
        "sourceTitle": "Real Carbon Fiber Center Console Armrest Cover Trim For Tesla Model Y L 2026.06+",
        "handle": "real-carbon-fiber-center-console-armrest-cover-trim-for-tesla-model-y-l-2026-06",
        "variant": "53188382621985",
        "price": 149,
        "fit": "Model Y L (2026.06+) / Matte",
        "sourceVariant": "Model Y L (2026.06+) / Matte",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/HM3MYJuniper_4.jpg?v=1744268351",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-1-6",
        "title": "V3 Screen Swivel Mount",
        "sourceTitle": "Swivel Mount Kit Center Screen Rotating Holder New Upgraded V2 & V3 Version For Tesla Model 3/Y/3 Highland/ Y Juniper/Y L",
        "handle": "tesla-screen-swivel-mount-model-3-y-highland-juniper",
        "variant": "52797048324385",
        "price": 109,
        "fit": "Model Y L （2025.08+） / New Upgraded V3 Version-does not lower the screen height / Left Hand Drive",
        "sourceVariant": "Model Y L （2025.08+） / New Upgraded V3 Version-does not lower the screen height / Left Hand Drive",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Swivel_Mount_Kit_Center_Screen_Rotating_Holder_New_Upgraded_V2_V3_Version_For_Tesla_Model_3_Y_3_Highland_Model_Y_Juniper.jpg?v=1760346783",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-1-7",
        "title": "Soft-Close Frunk Lock",
        "sourceTitle": "Front Trunk Electric Suction Lock For Tesla Model Y / 3 / 3 Highland / Y Juniper/Y L",
        "handle": "power-frunk-soft-close-lock-for-tesla-model-3-y-highland-juniper",
        "variant": "52797075390753",
        "price": 106,
        "fit": "model Y L（2025.08+）",
        "sourceVariant": "model Y L（2025.08+）",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Front_Trunk_Electric_Suction_Lock_For_Tesla_Model_Y_3_Model_3_Highland_Model_Y_Juniper.jpg?v=1760349516",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-1-8",
        "title": "Center Console USB Hub",
        "sourceTitle": "Center Console USB Hub for Tesla Model Y Juniper 2025+/ Model 3 Highland 2023+",
        "handle": "center-console-usb-hub-for-tesla-model-y-juniper-2025-model-3-highland-2023",
        "variant": "53175603298593",
        "price": 62,
        "fit": "Model Y L (2026.06+)",
        "sourceVariant": "Model Y L (2026.06+)",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Center_Console_USB_Hub_for_Tesla_Model_Y_Juniper_2025_Model_3_Highland_2023.png?v=1770357428",
        "tag": "HALLOWEEN UPGRADE"
      }
    ]
  },
  {
    "name": "Model Y Standard",
    "slug": "model-y-standard-accessories",
    "title": "Small Details. A More Personal Model Y.",
    "copy": "Explore carbon-fiber accents, travel storage and console upgrades for your Model Y Standard.",
    "items": [
      {
        "id": "model-2-0",
        "title": "Carbon Fiber Door Handle Covers",
        "sourceTitle": "Carbon Fiber Door Handle Covers for Tesla Model 3 / Model 3 Standard / Model Y / Model Y Juniper / Model Y Standard / Model Y L",
        "handle": "carbon-fiber-door-handle-covers-for-tesla-model-3-model-3-standard-model-y-model-y-juniper-model-y-standard-model-y-l",
        "variant": "53489976148257",
        "price": 74,
        "fit": "Model Y Standard (2025.11+) / Gloss",
        "sourceVariant": "Model Y Standard (2025.11+) / Gloss",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/6_5a0ca646-3bcd-4992-a66c-c2c3a8b0aec2.png?v=1789107116",
        "tag": "CARBON ACCENTS"
      },
      {
        "id": "model-2-1",
        "title": "Tactical Camping Storage Bags",
        "sourceTitle": "Triangle Window Tactical Camping Storage Bag Pair for Tesla",
        "handle": "triangle-window-tactical-camping-storage-bag-pair-for-tesla",
        "variant": "53474978890017",
        "price": 224,
        "fit": "Model Y / Model Y Juniper / Model Y Standard",
        "sourceVariant": "Model Y / Model Y Juniper / Model Y Standard",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/ModelYJuniper_eb962455-873d-4f71-8622-4fbde4942d76.png?v=1788917250",
        "tag": "TRAVEL STORAGE"
      },
      {
        "id": "model-2-2",
        "title": "Aroma Diffuser Dock",
        "sourceTitle": "Aroma Diffuser Dock for Tesla Model 3, Model 3 Highland, Model Y, Model Y Juniper, and Model Y L",
        "handle": "aroma-diffuser-dock-for-tesla-model-3-model-3-highland-model-y-model-y-juniper-and-model-y-l",
        "variant": "53242325827873",
        "price": 124,
        "fit": "Model Y Standard (2025.11+)",
        "sourceVariant": "Model Y Standard (2025.11+)",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/tesla-aroma-diffuser-dock-center-console-fit.jpg?v=1786435676",
        "tag": "CONSOLE UPGRADE"
      },
      {
        "id": "model-2-3",
        "title": "Cup Holder Storage Box",
        "sourceTitle": "Black Silicone Center Console Cup Holder Storage Box for Tesla Model Y Standard 2025.11+",
        "handle": "black-silicone-center-console-cup-holder-storage-box-for-tesla-model-y-standard-2025-11",
        "variant": "53420495208737",
        "price": 49,
        "fit": "Model Y Standard (2025.11+)",
        "sourceVariant": "Model Y Standard (2025.11+)",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/20260901-182546.png?v=1788258396",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-2-4",
        "title": "18-inch Blade Wheel Covers",
        "sourceTitle": "Model Y Standard 18-Inch Blade-Style Aero Wheel Covers, Matte Black (2025.11+)",
        "handle": "model-y-standard-18-inch-aero-wheel-covers",
        "variant": "52939484299553",
        "price": 163,
        "fit": "Model Y Standard · 2025.11+ · 18-inch Blade Wheel Covers",
        "sourceVariant": "Default Title",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/61KqZjHDpTL._AC_SL1500.jpg?v=1782979051",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-2-5",
        "title": "All-Weather Frunk Mat",
        "sourceTitle": "Tesla Model Y Standard TPE Front Trunk Mat | 3D Precision Fit Waterproof Frunk Liner",
        "handle": "front-trunk-mat-for-model-y-standard",
        "variant": "52885817917729",
        "price": 62,
        "fit": "Model Y Standard · 2025.11+ · All-Weather Frunk Mat",
        "sourceVariant": "Default Title",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/tesery-tpe-front-trunk-mat-for-tesla-model-y-standard-1536413.jpg?v=1782202706",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-2-6",
        "title": "Trunk Organizer Bins",
        "sourceTitle": "Tesla Model Y Juniper & Standard Trunk Organizer Bins | Waterproof TPE Storage with Carpeted Lids",
        "handle": "tesla-model-y-juniper-trunk-storage-bins-organizers",
        "variant": "52885775581473",
        "price": 99,
        "fit": "Model Y Standard",
        "sourceVariant": "Model Y Standard",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/YESLAK_Custom-Fit_Trunk_Organizer_Bins_for_2026_Tesla_Model_Y_Juniper_Premium_Hidden_Storage_Cargo_Space_Upgrade_German_Berlin_Models_Available_7.jpg?v=1782201367",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-2-7",
        "title": "Rear Seat Back Protector Mats",
        "sourceTitle": "Tesla Model Y Standard Rear Seat Back Protector Mat – 3PCS All-Weather Trunk Liner",
        "handle": "model-y-standard-backrest-mat-cargo-liner",
        "variant": "52882131386657",
        "price": 99,
        "fit": "Model Y Standard · 2025.11+ · Rear Seat Back Protector Mats",
        "sourceVariant": "Default Title",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/61mbTbtSCvL._AC_SL1500.jpg?v=1782184397",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-2-8",
        "title": "Rear Air Vent Guard",
        "sourceTitle": "Tesla Model Y Standard Rear Air Vent Guard | Rear Seat AC Outlet Protector",
        "handle": "tesla-model-y-standard-rear-air-vent-guard-ac-protector",
        "variant": "52882126733601",
        "price": 24,
        "fit": "Model Y Standard · 2025.11+ · Rear Air Vent Guard",
        "sourceVariant": "Default Title",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/616T6eFY02L._AC_SL1500.jpg?v=1782184378",
        "tag": "HALLOWEEN UPGRADE"
      }
    ]
  },
  {
    "name": "Model Y",
    "slug": "model-y-accessories",
    "title": "Fresh Treats for Your Model Y",
    "copy": "Explore everyday comfort, rear-seat entertainment and screen-position upgrades.",
    "items": [
      {
        "id": "model-3-0",
        "title": "Adjustable Neck Pillow",
        "sourceTitle": "SPA Neck Pillow Adjustable Skin-friendly Headrest For Model 3/Y/ 3 Highland / Model Y Juniper",
        "handle": "spa-neck-pillow-adjustable-headrest-tesla-model-3-y",
        "variant": "51047404601633",
        "price": 82,
        "fit": "1pc / Black / Model Y （2019-2024）",
        "sourceVariant": "1pc / Black / Model Y （2019-2024）",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/TeslaModel3YModel3HighlandCybertruckNeckPillowAdjustableSkin-friendlyHeadrestNeckPillow_2_e47bb44b-db8c-4126-bd69-bd6aa7b533cc.png?v=1734940003",
        "tag": "EVERYDAY COMFORT"
      },
      {
        "id": "model-3-1",
        "title": "R89 Plus Rear Display",
        "sourceTitle": "Tesla Model 3/Y Rear Entertainment Screen – R89 Plus Display for Road Trips",
        "handle": "model-3-y-r89-rear-display-with-disney-plus-entertainment-february-2019",
        "variant": "52401257185569",
        "price": 346,
        "fit": "R89 Plus Rear Display / Model Y (2019-2025.02)",
        "sourceVariant": "R89 Plus Rear Display / Model Y (2019-2025.02)",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/tesla-model-3-y-rear-entertainment-screen-dual-controller-gaming.jpg?v=1786066109",
        "tag": "REAR-SEAT ENTERTAINMENT"
      },
      {
        "id": "model-3-2",
        "title": "V3 Screen Swivel Mount",
        "sourceTitle": "Dashboard Screen Swivel Mount kit For Model 3/Y/3 Highland/Model Y Juniper/Y L",
        "handle": "model-3-y-3-highland-model-y-juniper-dashboard-screen-swivel-mount-kit",
        "variant": "51206652330273",
        "price": 109,
        "fit": "Model Y · 2021–2025.02 · V3 · Left-hand drive",
        "sourceVariant": "Model Y (2021- 02/2025) / New Upgraded V3 Version - does not lower the screen height / Left Hand Drive",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Dashboard_Screen_Swivel_Mount_kit_For_Model_3_Y_3_Highland_Model_Y_Juniper_-_Tesstudio.png?v=1777017684",
        "tag": "SCREEN UPGRADE"
      },
      {
        "id": "model-3-3",
        "title": "Nappa Leather Leg Support",
        "sourceTitle": "Tesla Model 3 / Model 3 Highland / Model Y / Model Y Juniper / Model Y Standard Premium Nappa Leather Front Seat Leg Support Cushion",
        "handle": "front-seat-leg-support-nappa-cushion-for-tesla-model-3-y",
        "variant": "51934265409825",
        "price": 96,
        "fit": "Model Y（2019-2024） / Black（1 Pcs）",
        "sourceVariant": "Model Y（2019-2024） / Black（1 Pcs）",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_2026_Premium_Nappa_Leather_Front_Seat_Leg_Support_Cushion_For_Model_3_3_Highland_Y_Y_Juniper_Black_1_Pcs.png?v=1764036958",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-3-4",
        "title": "Power Frunk Lift Kit",
        "sourceTitle": "Power Frunk Automatic opening system For Tesla Model 3/Y/3 Highland/ Y Juniper",
        "handle": "power-frunk-silent-front-trunk-electric-suction-lock-v8",
        "variant": "50793713041697",
        "price": 400,
        "fit": "Model Y (2019-02/2025) (Not support 23-25.2 Berlin and Austin)",
        "sourceVariant": "Model Y (2019-02/2025) (Not support 23-25.2 Berlin and Austin)",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Model_Y_2023-02_2025_Power_Frunk_Automatic_opening_system_For_Tesla_Austin_Made_in_Berlin_-_Tesstudio.jpg?v=1780556899",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-3-5",
        "title": "Hands-Free Trunk Opener",
        "sourceTitle": "Tesla Model Y Hands-Free Trunk Opener — Kick-to-Open LiDAR Sensor",
        "handle": "laser-projection-hands-free-trunk-opener-system-kick-to-open",
        "variant": "52480287867169",
        "price": 124,
        "fit": "Model Y（2019-2025.02）",
        "sourceVariant": "Model Y（2019-2025.02）",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Kick-to-Open_Rear_Trunk_Sensor_System_for_Tesla_Model_Y_Y_Juniper.png?v=1776156888",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-3-6",
        "title": "App-Controlled Door LED Lights",
        "sourceTitle": "Door LED Strip Lights with APP Control for Tesla Model 3 / 3 Highland / Model Y / Y Juniper/Y L",
        "handle": "door-led-strip-lights-with-app-control-for-tesla-model-3-y-interior-ambient-lighting",
        "variant": "52620868518177",
        "price": 115,
        "fit": "Model Y (2020+)",
        "sourceVariant": "Model Y (2020+)",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Door_LED_Strip_Lights_with_APP_Control_for_Tesla_Model_3_3_Highland_Model_Y_Y_Juniper_Interior_Ambient_Lighting.png?v=1778059776",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-3-7",
        "title": "Carbon Fiber Trunk Lip Spoiler",
        "sourceTitle": "Tesstudio Real Carbon Fiber Rear Trunk Lip Spoiler For Model 3/Y",
        "price": 207,
        "variant": "49746894258465",
        "fit": "Model Y · Matte real carbon fiber",
        "handle": "model-3-y-real-carbon-fiber-rear-trunk-lip-spoiler",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/5-2_c290d588-3dab-40e6-89ab-bc0e1cb46114.jpg?v=1720075676",
        "source": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/5-2_c290d588-3dab-40e6-89ab-bc0e1cb46114.jpg?v=1720075676",
        "sourceVariant": "Matte / Model Y",
        "checked": "2026-10-16"
      },
      {
        "id": "model-3-8",
        "title": "Car Door Seal Kit",
        "sourceTitle": "Car Door Seal Kit For Tesla Model 3/3 Highland/Y/Y Juniper/Y L/Y Standard | Soundproof Rubber Weatherstrip",
        "handle": "tesla-model-3-y-car-door-seal-kit-soundproof-rubber-accessories",
        "variant": "50758692143393",
        "price": 66,
        "fit": "Model Y/Y Juniper",
        "sourceVariant": "Model Y/Y Juniper",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Car_Door_Seal_Kit_Soundproof_Rubber_For_Tesla_Model_3_Y_Accessories.jpg?v=1761897470",
        "tag": "HALLOWEEN UPGRADE"
      }
    ]
  },
  {
    "name": "Model 3 Highland",
    "slug": "model-3-highland-accessories",
    "title": "Give Your Highland a Halloween Upgrade",
    "copy": "Explore console charging, ambient lighting and screen-position upgrades for your Model 3 Highland.",
    "items": [
      {
        "id": "model-4-0",
        "title": "Center Console USB Hub",
        "sourceTitle": "Center Console USB Hub for Tesla Model Y Juniper 2025+/ Model 3 Highland 2023+",
        "handle": "center-console-usb-hub-for-tesla-model-y-juniper-2025-model-3-highland-2023",
        "variant": "52297746678049",
        "price": 62,
        "fit": "Model 3 Highland（2023.08+）",
        "sourceVariant": "Model 3 Highland（2023.08+）",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Center_Console_USB_Hub_for_Tesla_Model_Y_Juniper_2025_Model_3_Highland_2023.png?v=1770357428",
        "tag": "CONSOLE ESSENTIAL"
      },
      {
        "id": "model-4-1",
        "title": "BSD Ambient Light System",
        "sourceTitle": "BSD Blind Spot Monitor Ambient Light System For Tesla Model 3/Y / 3 Highland / Y Juniper/ Y L",
        "handle": "tesla-bsd-blind-spot-ambient-light",
        "variant": "51411743605025",
        "price": 69,
        "fit": "Model 3 Highland (2023.8+）",
        "sourceVariant": "Model 3 Highland (2023.8+）",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/img_v3_02og_16667a9f-45d6-4c3a-9622-070e1e6e1e0g.jpg?v=1773734289",
        "tag": "CABIN ATMOSPHERE"
      },
      {
        "id": "model-4-2",
        "title": "V2 Screen Swivel Mount",
        "sourceTitle": "Swivel Mount Kit Center Screen Rotating Holder New Upgraded V2 & V3 Version For Tesla Model 3/Y/3 Highland/ Y Juniper/Y L",
        "handle": "tesla-screen-swivel-mount-model-3-y-highland-juniper",
        "variant": "50793369436449",
        "price": 84,
        "fit": "Model 3 Highland · 2023.08+ · V2 · Left-hand drive",
        "sourceVariant": "Model 3 Highland (2023.08+) / Upgraded V2 Version / Left Hand Drive",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Swivel_Mount_Kit_Center_Screen_Rotating_Holder_New_Upgraded_V2_V3_Version_For_Tesla_Model_3_Y_3_Highland_Model_Y_Juniper.jpg?v=1760346783",
        "tag": "SCREEN UPGRADE"
      },
      {
        "id": "model-4-3",
        "title": "Car Door Seal Kit",
        "sourceTitle": "Car Door Seal Kit For Tesla Model 3/3 Highland/Y/Y Juniper/Y L/Y Standard | Soundproof Rubber Weatherstrip",
        "handle": "tesla-model-3-y-car-door-seal-kit-soundproof-rubber-accessories",
        "variant": "50758692110625",
        "price": 66,
        "fit": "Model 3/3 Highland",
        "sourceVariant": "Model 3/3 Highland",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Car_Door_Seal_Kit_Soundproof_Rubber_For_Tesla_Model_3_Y_Accessories.jpg?v=1761897470",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-4-4",
        "title": "Power Frunk Lift Kit",
        "sourceTitle": "Power Frunk Automatic opening system For Tesla Model 3/Y/3 Highland/ Y Juniper",
        "handle": "power-frunk-silent-front-trunk-electric-suction-lock-v8",
        "variant": "50793713008929",
        "price": 400,
        "fit": "Model 3 Highland(08/2023 +)",
        "sourceVariant": "Model 3 Highland(08/2023 +)",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Model_3_Highland_Power_Frunk_Automatic_opening_system_For_Tesla_-_Tesstudio.jpg?v=1780555844",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-4-5",
        "title": "Adjustable Neck Pillow",
        "sourceTitle": "SPA Neck Pillow Adjustable Skin-friendly Headrest For Model 3/Y/ 3 Highland / Model Y Juniper",
        "handle": "spa-neck-pillow-adjustable-headrest-tesla-model-3-y",
        "variant": "51047404568865",
        "price": 82,
        "fit": "1pc / Black / Model 3 Highland（2024-2025）",
        "sourceVariant": "1pc / Black / Model 3 Highland（2024-2025）",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/TeslaModel3YModel3HighlandCybertruckNeckPillowAdjustableSkin-friendlyHeadrestNeckPillow_2_e47bb44b-db8c-4126-bd69-bd6aa7b533cc.png?v=1734940003",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-4-6",
        "title": "F9 Pro Dashboard Display",
        "sourceTitle": "F9 Pro CarPlay Screen Dashboard Display for Tesla Model 3/3 Highland Model Y/Y Juniper/Y L",
        "handle": "tesla-model-3-3-highland-model-y-y-juniper-f9-pro-touchscreen-dashboard-display",
        "variant": "51364179738913",
        "price": 368,
        "fit": "Model 3 Highland (2023.08+) / Without Camera / Left Hand Drive",
        "sourceVariant": "Model 3 Highland (2023.08+) / Without Camera / Left Hand Drive",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/F9_Pro_CarPlay_Screen_Dashboard_Display_for_Tesla_Model_3_Y_Juniper.png?v=1774596777",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-4-7",
        "title": "Center Console Lockbox",
        "sourceTitle": "Center Console Safe LockBox Insert Lock Insurance Vault Box for Model 3 Highland/Y Juniper",
        "handle": "tesla-center-console-lock-box-armrest-safe-vault-organizer-for-model-3-highland-y-juniper",
        "variant": "51654492291361",
        "price": 143,
        "fit": "Model 3 Highland(2023.08+)",
        "sourceVariant": "Model 3 Highland(2023.08+)",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/img_v3_02pq_924413ce-4639-4e12-b6d5-f26d6e72d8fg.png?v=1756976161",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-4-8",
        "title": "Front & Rear Screen Protectors",
        "sourceTitle": "Tesstudio Tesla Accessories Model 3 Highland Model Y Juniper 15.4\" Tempered Glass Screen Protector Set for Front & Rear Displays",
        "handle": "tesstudio-tesla-model-3-highland-tempered-glass-screen-protector-set-for-front-rear-displays",
        "variant": "49243007746337",
        "price": 38,
        "fit": "HD / Model 3 Highland (2024+)",
        "sourceVariant": "HD / Model 3 Highland (2024+)",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio-Tesla-Model-3-Highland-Screen-Protector01-1.jpg?v=1750928590",
        "tag": "HALLOWEEN UPGRADE"
      }
    ]
  },
  {
    "name": "Model 3",
    "slug": "model-3-accessories",
    "title": "Make Your Model 3 Feel More Like You",
    "copy": "Shop comfort, rear-seat entertainment and screen-position upgrades for your Model 3.",
    "items": [
      {
        "id": "model-5-0",
        "title": "Adjustable Neck Pillow",
        "sourceTitle": "SPA Neck Pillow Adjustable Skin-friendly Headrest For Model 3/Y/ 3 Highland / Model Y Juniper",
        "handle": "spa-neck-pillow-adjustable-headrest-tesla-model-3-y",
        "variant": "50697969467681",
        "price": 82,
        "fit": "1pc / Black / Model 3 (2017-2023)",
        "sourceVariant": "1pc / Black / Model 3 (2017-2023)",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/TeslaModel3YModel3HighlandCybertruckNeckPillowAdjustableSkin-friendlyHeadrestNeckPillow_2_e47bb44b-db8c-4126-bd69-bd6aa7b533cc.png?v=1734940003",
        "tag": "EVERYDAY COMFORT"
      },
      {
        "id": "model-5-1",
        "title": "R89 Plus Rear Display",
        "sourceTitle": "Tesla Model 3/Y Rear Entertainment Screen – R89 Plus Display for Road Trips",
        "handle": "model-3-y-r89-rear-display-with-disney-plus-entertainment-february-2019",
        "variant": "52401257152801",
        "price": 346,
        "fit": "R89 Plus Rear Display / Model 3 (2020-2023.07)",
        "sourceVariant": "R89 Plus Rear Display / Model 3 (2020-2023.07)",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/tesla-model-3-y-rear-entertainment-screen-dual-controller-gaming.jpg?v=1786066109",
        "tag": "REAR-SEAT ENTERTAINMENT"
      },
      {
        "id": "model-5-2",
        "title": "V3 Screen Swivel Mount",
        "sourceTitle": "Dashboard Screen Swivel Mount kit For Model 3/Y/3 Highland/Model Y Juniper/Y L",
        "handle": "model-3-y-3-highland-model-y-juniper-dashboard-screen-swivel-mount-kit",
        "variant": "51206647841057",
        "price": 109,
        "fit": "Model 3 · 2021–2023.07 · V3 · Left-hand drive",
        "sourceVariant": "Model 3 (2021-07/2023) / New Upgraded V3 Version - does not lower the screen height / Left Hand Drive",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Dashboard_Screen_Swivel_Mount_kit_For_Model_3_Y_3_Highland_Model_Y_Juniper_-_Tesstudio.png?v=1777017684",
        "tag": "SCREEN UPGRADE"
      },
      {
        "id": "model-5-3",
        "title": "Door Handle Covers",
        "sourceTitle": "ABS Carbon Fiber Door Handle Cover Protection Accessories for Tesla Model 3/3 Standard/Y/Y L/Y Standard",
        "handle": "tesla-model-3-y-carbon-fiber-door-handle-cover-protection-accessories",
        "variant": "51356404285729",
        "price": 18,
        "fit": "Model 3 / Matte",
        "sourceVariant": "Model 3 / Matte",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/TeslaModel3YCarbonFiberDoorHandleCoverProtectionAccessoriesTesstudio_1.jpg?v=1749439575",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-5-4",
        "title": "Tempered Glass Screen Protector",
        "sourceTitle": "Tesla Model Y & Model 3 Tempered Glass Screen Protector | 9H Auto-Alignment Kit (Matte / HD Clear)",
        "handle": "model-3-y-tempered-glass-screen-protector-with-auto-alignment-mount-kit",
        "variant": "49746807685409",
        "price": 15,
        "fit": "HD Clear Finish",
        "sourceVariant": "HD Clear Finish",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/1-43.jpg?v=1720074628",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-5-5",
        "title": "Non-Slip Pedal Covers",
        "sourceTitle": "Brake Pedal Foot Pedals Non-Slip Performance Foot Rest For Tesla Model 3/Y/3 Highland /Model Y Juniper/Standard",
        "handle": "tesla-brake-pedal-model-3-y-3-highland-model-y-juniper-foot-pedals-non-slip-performance-foot-rest-tesstudio®",
        "variant": "51231653298465",
        "price": 24,
        "fit": "Black / Model 3",
        "sourceVariant": "Black / Model 3",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/SKU-02-22_Model3_Y_2.jpg?v=1745825692",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-5-6",
        "title": "Car Door Seal Kit",
        "sourceTitle": "Car Door Seal Kit For Tesla Model 3/3 Highland/Y/Y Juniper/Y L/Y Standard | Soundproof Rubber Weatherstrip",
        "handle": "tesla-model-3-y-car-door-seal-kit-soundproof-rubber-accessories",
        "variant": "50758692110625",
        "price": 66,
        "fit": "Model 3/3 Highland",
        "sourceVariant": "Model 3/3 Highland",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Car_Door_Seal_Kit_Soundproof_Rubber_For_Tesla_Model_3_Y_Accessories.jpg?v=1761897470",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-5-7",
        "title": "Power Frunk Lift Kit",
        "sourceTitle": "Power Frunk Automatic opening system For Tesla Model 3/Y/3 Highland/ Y Juniper",
        "handle": "power-frunk-silent-front-trunk-electric-suction-lock-v8",
        "variant": "50793712976161",
        "price": 400,
        "fit": "Model 3 (2021-2023)",
        "sourceVariant": "Model 3 (2021-2023)",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Model_3_2021_Electric_Frunk_Suction_Soft_Closing_Motor_Knocking_Unlock_Sensor_For_Tesla_Power_Frunk_Knock_Sensor_-_Tesstudio.jpg?v=1780560002",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-5-8",
        "title": "Nappa Leather Leg Support",
        "sourceTitle": "Tesla Model 3 / Model 3 Highland / Model Y / Model Y Juniper / Model Y Standard Premium Nappa Leather Front Seat Leg Support Cushion",
        "handle": "front-seat-leg-support-nappa-cushion-for-tesla-model-3-y",
        "variant": "51934265213217",
        "price": 96,
        "fit": "Model 3（2019-2023.07） / Black（1 Pcs）",
        "sourceVariant": "Model 3（2019-2023.07） / Black（1 Pcs）",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_2026_Premium_Nappa_Leather_Front_Seat_Leg_Support_Cushion_For_Model_3_3_Highland_Y_Y_Juniper_Black_1_Pcs.png?v=1764036958",
        "tag": "HALLOWEEN UPGRADE"
      }
    ]
  },
  {
    "name": "Cybertruck",
    "slug": "cybertruck-accessories",
    "title": "Gear Up Your Cybertruck",
    "copy": "Explore cabin storage, screen-position upgrades and door seals for your Cybertruck.",
    "items": [
      {
        "id": "model-6-0",
        "title": "Rear Underseat Storage Tool Box",
        "sourceTitle": "Rear Underseat Storage Tool Box For Cybertruck Premium AWD 2024+",
        "handle": "rear-underseat-storage-tool-box-for-tesla-cybertruck",
        "variant": "50624715489569",
        "price": 114,
        "fit": "Cybertruck Premium AWD 2024+ / Storage Box only",
        "sourceVariant": "Storage Box",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Cybertruck_afc98767-5320-47de-a0e8-eab5774f3e30.jpg?v=1774925976",
        "tag": "CABIN STORAGE"
      },
      {
        "id": "model-6-1",
        "title": "V3 Screen Swivel Mount",
        "sourceTitle": "Center Screen Swivel Rotating Mount Kit V3 (Original Screen Height,More Easy Install) For Cybertruck",
        "handle": "cybertruck-screen-swivel-tilt-mount-rotating-holder",
        "variant": "51953731600673",
        "price": 158,
        "fit": "Cybertruck Premium AWD · 2024+ · V3 mount kit",
        "sourceVariant": "Cybertruck Premium AWD 2024+ / Swivel Bracket Mount Kit V3(More Easy Install)",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Center_Screen_Swivel_Rotating_Mount_Kit_For_Cybertruck_Swivel_Bracket_Mount_Kit_V3_More_Easy_Install.png?v=1772675332",
        "tag": "SCREEN UPGRADE"
      },
      {
        "id": "model-6-2",
        "title": "Car Door Seal Kit",
        "sourceTitle": "Car Door Seal Kit Soundproof Wind Noise Reduction For Cybertruck",
        "handle": "cybertruck-car-door-seal-kit-noise-reduction",
        "variant": "52901758435617",
        "price": 66,
        "fit": "Cybertruck Premium AWD 2024+",
        "sourceVariant": "Cybertruck Premium AWD 2024+",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Car_Door_Seal_Kit_Soundproof_Wind_Noise_Reduction_For_Cybertruck.jpg?v=1759990659",
        "tag": "FINISHING TOUCHES"
      },
      {
        "id": "model-6-3",
        "title": "Console USB Charging Hub",
        "sourceTitle": "Center Console USB Charger Hub for Tesla Cybertruck | Gen 1 & Gen 2",
        "handle": "cybertruck-center-console-110v-usb-charger-hub-ambient-lighting",
        "variant": "52056354488609",
        "price": 149,
        "fit": "Gen 2 · Ambient Lighting Hub",
        "sourceVariant": "Gen 2 · Ambient Lighting Hub",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Center_Console_USB_Charger_Hub_for_Tesla_Cybertruck_Gen_1_Gen_2_-_Tesstudio.jpg?v=1789351945",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-6-4",
        "title": "Welcome Projection Lights",
        "sourceTitle": "Projection Lights Cybertruck Welcome Puddle Lights For Tesla Cybertruck",
        "handle": "projection-welcome-puddle-lights-for-tesla-cybertruck",
        "variant": "50833138319649",
        "price": 49,
        "fit": "4 Pcs / Cricut Friendly Cybertruck Logo",
        "sourceVariant": "4 Pcs / Cricut Friendly Cybertruck Logo",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Projection_Lights_Cybertruck_Welcome_Puddle_Lights_For_Tesla_Cybertruck.jpg?v=1787882965",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-6-5",
        "title": "Cargo Bed Divider",
        "sourceTitle": "Vault Cargo Divider Rear Trunk Bed Divider For Tesla Cybertruck Premium AWD 2024+",
        "handle": "tesstudio-tesla-accessories-cargo-divider-for-tesla-cybertruck",
        "variant": "50262767829281",
        "price": 379,
        "fit": "Cybertruck Premium AWD 2024+ / Vertical Style / Cargo Divider",
        "sourceVariant": "Cybertruck Premium AWD 2024+ / Vertical Style / Cargo Divider",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Vault_Cargo_Divider_Rear_Trunk_Bed_Divider_For_Tesla_Cybertruck.jpg?v=1779863196",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-6-6",
        "title": "All-Weather Mud Flaps",
        "sourceTitle": "Tesla Cybertruck Mud Flaps OEM Style Splash Guards Front Rear Set (4PCS)",
        "handle": "tesla-cybertruck-mud-flaps-oem-splash-guards",
        "variant": "49996668305697",
        "price": 90,
        "fit": "Cybertruck Premium AWD 2024+ / OEM Style",
        "sourceVariant": "Cybertruck Premium AWD 2024+ / OEM Style",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/1_89d0dfdd-a9ba-4fa9-8916-46b8f83cc531.jpg?v=1721811525",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-6-7",
        "title": "Under-Seat Storage Boxes",
        "sourceTitle": "Tesla Cybertruck Under-Seat Storage Box",
        "handle": "underseat-storage-box-for-tesla-cybertruck",
        "variant": "50381185941793",
        "price": 51,
        "fit": "Cybertruck Premium AWD 2024+ / 2pcs",
        "sourceVariant": "Cybertruck Premium AWD 2024+ / 2pcs",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Cybertrunk_-_B_1.jpg?v=1727591949",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-6-8",
        "title": "Center Console Organizer",
        "sourceTitle": "Center Console Organizer Tray Storage Box For Cybertruck",
        "handle": "tesstudio-cybertruck-center-console-organizer-tray-storage-box-tesla-interior-accessories",
        "variant": "50271626461473",
        "price": 29,
        "fit": "Cybertruck Premium AWD 2024+",
        "sourceVariant": "Cybertruck Premium AWD 2024+",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/TesstudioCybertruckCenterConsoleOrganizerTrayStorageBox-3.webp?v=1725641124",
        "tag": "HALLOWEEN UPGRADE"
      }
    ]
  },
  {
    "name": "Model S",
    "slug": "model-s-accessories",
    "title": "A Personal Touch for Your Model S",
    "copy": "Explore wheel styling, carbon-fiber accents and front-seat comfort for your Model S.",
    "items": [
      {
        "id": "model-7-0",
        "title": "19-inch Arachnid Wheel Covers",
        "sourceTitle": "Wheel Covers Hub Cap For Tesla Model 3/Y/3 Highland Model S/X",
        "handle": "tesla-model-3-y-3-highland-wheel-covers-wheel-hub-cap-tesstudio®",
        "variant": "50961757765921",
        "price": 179,
        "fit": "Model S (2022+) / Arachnid 19''",
        "sourceVariant": "Model S (2022+) / Arachnid 19''",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/19-arachnid-style-wheel-cover-for-tesla-model-sy-826954_1bd07ce6-2a24-4994-8bb7-b6ba70a13163.jpg?v=1757298261",
        "tag": "WHEEL STYLING"
      },
      {
        "id": "model-7-1",
        "title": "Carbon Fiber Rear Spoiler",
        "sourceTitle": "Real Carbon Fiber Tail Spoiler Wing For Tesla Model 3/Y/S  Model Y Juniper",
        "handle": "tesla-model-3-y-s-model-y-juniper-real-carbon-fiber-tail-spoiler-wing",
        "variant": "51239499301153",
        "price": 240,
        "fit": "Model S （2016-2021） / Real Carbon Fiber - Matte",
        "sourceVariant": "Model S （2016-2021） / Real Carbon Fiber - Matte",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Real_Carbon_Fiber_Tail_Spoiler_Wing_For_Tesla_Model_3_Y_S_Model_Y_Juniper.jpg?v=1765164535",
        "tag": "CARBON ACCENTS"
      },
      {
        "id": "model-7-2",
        "title": "Cooling & Massage Seat Cover",
        "sourceTitle": "Breathable Massaging Car Seat Cover For Tesla Model 3/Y/3 Highland/Y Juniper/Y Standard/Y L/Cybertruck",
        "handle": "tesstudio-ultimate-comfort-tesla-front-seat-cooling-seat-cover-with-16-fans-and-massage",
        "variant": "51047411613985",
        "price": 120,
        "fit": "Model S / Blue / Single Seat",
        "sourceVariant": "Model S / Blue / Single Seat",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/img_v3_02129_ea852158-ba2a-40c4-8698-cffef432e9ag.jpg?v=1780380596",
        "tag": "SEAT COMFORT"
      },
      {
        "id": "model-7-3",
        "title": "Nappa Leather Headrest Pillows",
        "sourceTitle": "Tesstudio Nappa Leather Headrest Pillow 2 Packs for Tesla Neck Pillow Uniquely Designed for Tesla Model Y/3/S/X",
        "price": 73,
        "variant": "51936199049505",
        "fit": "Model S · Black · 2-piece set",
        "handle": "2026-tesstudio-nappa-leather-headrest-pillow-2-packs-for-tesla-neck-pillow-uniquely-designed-for-tesla-model-y-3-s-x",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/61a8eHRtRhL._AC_SL1001.jpg?v=1761112859",
        "source": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/61a8eHRtRhL._AC_SL1001.jpg?v=1761112859",
        "sourceVariant": "Black（2PCS）",
        "checked": "2026-10-16"
      },
      {
        "id": "model-7-4",
        "title": "Coiled USB-C Charging Cable",
        "sourceTitle": "4ft (1.2m) Spring USB-C Cable for Tesla Model Y/3/X/S/Y Standard, Cybertruck-Style Accessories",
        "handle": "4ft-1-2m-spring-usb-c-cable-for-tesla-model-y-3-x-s-cybertruck-style-accessories",
        "variant": "51917954482465",
        "price": 60,
        "fit": "Model S/X/3/Y/Y Standard/Cybertruck(General)",
        "sourceVariant": "Model S/X/3/Y/Y Standard/Cybertruck(General)",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_4ft_1.2m_Spring_USB-C_Cable_for_Tesla_Model_Y_3_X_S_Cybertruck-Style_Accessories.jpg?v=1761287354",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-7-5",
        "title": "Seat Back Kick Protectors",
        "sourceTitle": "Premium Seat Back Kick Protector for Tesla Model 3/Y/X/S",
        "handle": "seat-back-kick-protector-for-tesla-model-3-y-x-s",
        "variant": "52032358351137",
        "price": 87,
        "fit": "Model 3/Y/X/S （2PCS）",
        "sourceVariant": "Model 3/Y/X/S （2PCS）",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Premium_Seat_Back_Kick_Protector_for_Tesla.jpg?v=1764043311",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-7-6",
        "title": "Cordless Vacuum & Inflator",
        "sourceTitle": "Model 3/Y/S/X/Cybertruck Handheld Cordless Vacuum Cleaner Inflatable Two-In-One",
        "handle": "model-3-y-s-x-handheld-cordless-vacuum-cleaner-inflatable-two-in-one",
        "variant": "52846689321249",
        "price": 99,
        "fit": "Model S · Handheld vacuum & inflator",
        "sourceVariant": "Default Title",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/4b399a9b2403f0a569ace08e36c560db.jpg?v=1781493063",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-7-7",
        "title": "Sun Visor Glasses Case",
        "sourceTitle": "Glasses Case Sun Visor Card Storage Sunglasses Storage Box for Tesla Model 3/Y/X/S",
        "handle": "tesla-model3-y-x-smulti-function-car-glasses-case-sun-visor-card-storage-sunglasses-case",
        "variant": "52846679654689",
        "price": 23,
        "fit": "Black",
        "sourceVariant": "Black",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/295bdbf2d17ba1d6e623b8895dc57b1f_65dd903b-24e3-4518-9e0e-1cde8bb7ebe1.jpg?v=1781492776",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-7-8",
        "title": "Power Frunk Lift Kit",
        "sourceTitle": "Tesla Model S Front Hood Lifting Electric Power Frunk Kits",
        "handle": "electric-power-frunk-lift-kit-tesla-model-s",
        "variant": "49746811683105",
        "price": 430,
        "fit": "Model S 2016-2020",
        "sourceVariant": "Model S 2016-2020",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Model_S_Electric_Power_Frunk_Front_Hood_Lifting_For_Tesla_-_Tesstudio.jpg?v=1780561520",
        "tag": "HALLOWEEN UPGRADE"
      }
    ]
  },
  {
    "name": "Model X",
    "slug": "model-x-accessories",
    "title": "Set the Mood in Your Model X",
    "copy": "Explore interior lighting, front-seat comfort and exterior protection for your Model X.",
    "items": [
      {
        "id": "model-8-0",
        "title": "RGB Ambient Lighting Kit",
        "sourceTitle": "Tesla Model X Laser-Carved RGB Ambient Lighting Kit (2022-2025.03)",
        "handle": "tesla-model-x-laser-carving-rgb-ambient-lighting-2022-2025",
        "variant": "50985100804385",
        "price": 825,
        "fit": "Model X · 2022–2025.03 · RGB lighting kit",
        "sourceVariant": "Default Title",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Ambient_Lighting_Laser_Carving_RGB_Lighting_2022-2025.03_For_Tesla_Model_X_-_Tesstudio.jpg?v=1779085828",
        "tag": "CABIN ATMOSPHERE"
      },
      {
        "id": "model-8-1",
        "title": "Cooling & Massage Seat Cover",
        "sourceTitle": "Breathable Massaging Car Seat Cover For Tesla Model 3/Y/3 Highland/Y Juniper/Y Standard/Y L/Cybertruck",
        "handle": "tesstudio-ultimate-comfort-tesla-front-seat-cooling-seat-cover-with-16-fans-and-massage",
        "variant": "51047411810593",
        "price": 120,
        "fit": "Model X / Blue / Single Seat",
        "sourceVariant": "Model X / Blue / Single Seat",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/img_v3_02129_ea852158-ba2a-40c4-8698-cffef432e9ag.jpg?v=1780380596",
        "tag": "SEAT COMFORT"
      },
      {
        "id": "model-8-2",
        "title": "All-Weather Mud Guards",
        "sourceTitle": "All-Weather Mud Guard Body Kits for Tesla Model X/3/Y",
        "handle": "2025-2026-all-weather-mud-guard-body-kits-for-tesla-model-x-3-y",
        "variant": "51936234045729",
        "price": 87,
        "fit": "2022-2025 Model X",
        "sourceVariant": "2022-2025 Model X",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/61Q7eru9f3L._AC_SL1500.jpg?v=1761113930",
        "tag": "EXTERIOR PROTECTION"
      },
      {
        "id": "model-8-3",
        "title": "Foldable Desk & Food Tray",
        "sourceTitle": "Tesstudio Foldable Desk Food Tray (Carbon Edition) for Tesla Model Y/3/S/X- Upgraded Table with Support Leg for Dining, in-Car Work, Travel and Outdoor",
        "price": 100,
        "variant": "51936228376865",
        "fit": "Model X · Carbon Edition · 1 piece · Use while parked",
        "handle": "tesstudio-foldable-desk-food-tray-carbon-edition-for-tesla-model-y-3-s-x-upgraded-table-with-support-leg-for-dining-in-car-work-travel-and-outdoor",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/513soJdsMGL._AC_UY879.jpg?v=1761113883",
        "source": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/513soJdsMGL._AC_UY879.jpg?v=1761113883",
        "sourceVariant": "1 PCS",
        "checked": "2026-10-16"
      },
      {
        "id": "model-8-4",
        "title": "Coiled USB-C Charging Cable",
        "sourceTitle": "4ft (1.2m) Spring USB-C Cable for Tesla Model Y/3/X/S/Y Standard, Cybertruck-Style Accessories",
        "handle": "4ft-1-2m-spring-usb-c-cable-for-tesla-model-y-3-x-s-cybertruck-style-accessories",
        "variant": "51917954482465",
        "price": 60,
        "fit": "Model S/X/3/Y/Y Standard/Cybertruck(General)",
        "sourceVariant": "Model S/X/3/Y/Y Standard/Cybertruck(General)",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_4ft_1.2m_Spring_USB-C_Cable_for_Tesla_Model_Y_3_X_S_Cybertruck-Style_Accessories.jpg?v=1761287354",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-8-5",
        "title": "Seat Back Kick Protectors",
        "sourceTitle": "Premium Seat Back Kick Protector for Tesla Model 3/Y/X/S",
        "handle": "seat-back-kick-protector-for-tesla-model-3-y-x-s",
        "variant": "52032358351137",
        "price": 87,
        "fit": "Model 3/Y/X/S （2PCS）",
        "sourceVariant": "Model 3/Y/X/S （2PCS）",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Tesstudio_Premium_Seat_Back_Kick_Protector_for_Tesla.jpg?v=1764043311",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-8-6",
        "title": "Cordless Vacuum & Inflator",
        "sourceTitle": "Model 3/Y/S/X/Cybertruck Handheld Cordless Vacuum Cleaner Inflatable Two-In-One",
        "handle": "model-3-y-s-x-handheld-cordless-vacuum-cleaner-inflatable-two-in-one",
        "variant": "52846689321249",
        "price": 99,
        "fit": "Model X · Handheld vacuum & inflator",
        "sourceVariant": "Default Title",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/4b399a9b2403f0a569ace08e36c560db.jpg?v=1781493063",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-8-7",
        "title": "Sun Visor Glasses Case",
        "sourceTitle": "Glasses Case Sun Visor Card Storage Sunglasses Storage Box for Tesla Model 3/Y/X/S",
        "handle": "tesla-model3-y-x-smulti-function-car-glasses-case-sun-visor-card-storage-sunglasses-case",
        "variant": "52846679654689",
        "price": 23,
        "fit": "Black",
        "sourceVariant": "Black",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/295bdbf2d17ba1d6e623b8895dc57b1f_65dd903b-24e3-4518-9e0e-1cde8bb7ebe1.jpg?v=1781492776",
        "tag": "HALLOWEEN UPGRADE"
      },
      {
        "id": "model-8-8",
        "title": "Power Frunk Lift Kit",
        "sourceTitle": "Electric Power Frunk Front Trunk Soft Closing Lock For Tesla Accessories Model X",
        "handle": "tesla-model-x-electric-power-frunk-soft-close",
        "variant": "50619981529377",
        "price": 429,
        "fit": "Model X 2015-2020",
        "sourceVariant": "Model X 2015-2020",
        "imageUrl": "https://cdn.shopify.com/s/files/1/0879/8928/9249/files/Electric_Power_Frunk_Front_Trunk_Soft_Closing_Lock_For_Tesla_Accessories_Model_X.jpg?v=1784110973",
        "tag": "HALLOWEEN UPGRADE"
      }
    ]
  }
];

